 document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.industry-multicolumn-swiper', {
    
    slidesPerView: 1, // default (mobile)
    slidesPerGroup: 1,
    spaceBetween: 12,
     scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1.15, // small devices
        spaceBetween: 21,
      },
      576: {
        slidesPerView: 2.39, // tablet
        spaceBetween: 24,
      },
       1024: {
        slidesPerView: 3, // tablet
        spaceBetween: 24,
      },
      1200: {
        slidesPerView: 4.2, // desktop
        spaceBetween: 24,
      }
    },

    // smooth UX
    grabCursor: true,
    loop: false, // change to true if you want infinite loop
    speed: 600,

  });
});